import { useEffect, useState } from "react";
import LoadingCircle from "../../utility/LoadingCircle";
import LocalReactPDFViewer from "./ReactPDFViewer";

export default function LocalPDFViewer({ dropboxPath, api, token, closeAction, title = "PDF Preview" }) {
	const [dropboxTempLink, setDropboxTempLink] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const isAndroid = /Android/i.test(navigator.userAgent);

	useEffect(() => {
		setIsLoading(true);
		fetch(api + "/project/dropbox/pdf", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + token,
			},
			body: JSON.stringify({ path: dropboxPath }),
		})
			.then((res) => {
				if (!res.ok) throw new Error("Failed to fetch PDF");
				return res.blob();
			})
			.then((blob) => {
				const objectUrl = URL.createObjectURL(blob);
				setDropboxTempLink(objectUrl);
			})
			.catch((err) => {
				console.error("Error fetching PDF:", err);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [dropboxPath, api, token]);

	if (isLoading) {
		return (
			<div className="fixed top-0 left-0 bg-black bg-opacity-50 w-full h-full z-[1000]">
				<div className="flex flex-col justify-center items-center w-full h-full p-4 rounded-md">
					<div className="bg-white flex justify-between flex-col items-center p-4  rounded-md">
						<LoadingCircle />
						<p>Downloading PDF...</p>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="fixed top-0 left-0 bg-black bg-opacity-50 w-full h-full z-[1000]">
			<div className="flex flex-col w-full h-full p-4 rounded-md">
				<div className="bg-gray-100 flex justify-between items-center p-4 rounded-t">
					<p className="font-semibold">{title}</p>
					<div>
						<button onClick={closeAction} className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded">
							Close
						</button>
					</div>
				</div>

				<div className="flex-grow  overflow-hidden border-t border-black bg-gray-100 rounded-b">
					{isAndroid ? (
						<LocalReactPDFViewer fileUrl={dropboxTempLink} onClose={closeAction} title={title} />
					) : (
						<iframe src={dropboxTempLink} className="w-full h-full" type="application/pdf" title="PDF Preview" />
					)}
				</div>
			</div>
		</div>
	);
}
